import React from 'react'
import { Auth } from "aws-amplify";
import axios from 'axios';
import './style.css'
import { useState, useEffect } from 'react'
import PasswordValidations from './PwdValidations';
import AuthLayout from './AuthLayout';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

function ResetPasswordForm(props) {

  const [verificationCode, setVerification] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [buttonStatus, setbuttonStatus] = useState(false)
  const [disableSendBtn, setDisableSendBtn] = useState(true)
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const handleConfirmVerification = (e) => {
    e.preventDefault();
    console.log('calling reset')
    console.log(props.email)
    console.log(verificationCode)
    console.log(password)
    if (password == confirmPassword) {
      props.toggleLoader(true)
      Auth.forgotPasswordSubmit(props.email, verificationCode, password)
        .then(async (data) => {
          let agentId = props.agentDetails.userAttributes.find(attr => attr.name === "custom:agentid")?.value;
          await captureEvents(agentId, props.email, "RESET_PASSWORD");
          props.toggleLoader(false)
          console.log('password reset success')
          console.log(data)
          window.location.reload()
        }
        )
        .catch(err => {
          props.toggleLoader(false)
          console.log(err.message)
          setErrorMessage(err.message)
        }
        );
    }
    else {
      setErrorMessage('Please enter same password')
      setbuttonStatus(true)
    }
  }



  const handleChange = (e) => {
    // console.log(e.target.value)
    // console.log(e.target.name)
    if (e.target.name == 'verificationCode') {
      setVerification(e.target.value)
    }
    else if (e.target.name == 'password') {
      setPassword(e.target.value)
    }
    else if (e.target.name == 'confirmPassword') {
      setConfirmPassword(e.target.value)
    }
    // if(password==confirmPassword){
    //   setbuttonStatus(false)
    // }
    // else{
    //   console.log(password)
    //   console.log(confirmPassword)
    // }

  };

  const captureEvents = async (agentId, email, eventState) => {
    try {
      let data = {
        agentId: agentId,
        eventState: eventState,
        createdBy: email,
      };
      let apiPath = process.env.REACT_APP_BASE_ROOT_URL + `/veraagency/api/v1/agent-event`;
      const response = await axios.post(apiPath, data);
      const responseData = response.data;
      return responseData;
    } catch (error) {
      console.error("API call failed", error);
    }
  };

  const toggleResetBtn = (allPassed) => {
    setDisableSendBtn(!allPassed);
  }

  return (

    <AuthLayout>
      <p style={{ marginTop: 0, paddingBottom: 16 }}>We have sent a password reset code by email to {props.destination}. Enter it below to reset your password.</p>
      <form className="auth-form">
        <input
          className="auth-input"
          type="text"
          placeholder="Enter code"
          name="verificationCode"
          required
          onChange={handleChange}
        />
        <div className="auth-input-wrap">
          <input
            className="auth-input"
            type={showPassword ? 'text' : 'password'}
            placeholder="New password"
            name="password"
            required
            onChange={handleChange}
          />
          <span className="auth-pwd-toggle" onClick={() => setShowPassword(!showPassword)}>
            {showPassword ? <VisibilityIcon style={{ height: '20px' }} /> : <VisibilityOffIcon style={{ height: '20px' }} />}
          </span>
        </div>
        <div className="auth-input-wrap">
          <input
            className="auth-input"
            type={showConfirmPassword ? 'text' : 'password'}
            placeholder="Enter new password again"
            name="confirmPassword"
            required
            onChange={handleChange}
          />
          <span className="auth-pwd-toggle" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
            {showConfirmPassword ? <VisibilityIcon style={{ height: '20px' }} /> : <VisibilityOffIcon style={{ height: '20px' }} />}
          </span>
        </div>
        <p className="a-errorMessage" hidden={errorMessage.length <= 0}>
          {errorMessage}
        </p>
        <PasswordValidations password={password} allPassed={toggleResetBtn} />
        <button disabled={disableSendBtn} type="submit" className="auth-btn-primary" onClick={handleConfirmVerification}>
          Change password
        </button>
      </form>
      <div className="auth-link-row" style={{ paddingTop: 17}}>
        <span>Go back to&nbsp;</span>
        <span className="forgot-pawd" onClick={() => props.gotoLoginScreen()}>&nbsp;Sign In</span>
      </div>
    </AuthLayout>



    // {/* <form onSubmit={props.handleSubmit}>
    //         <div className="container">
    //           <h1>reset password</h1>
    //           <p>Please fill in this form to login.</p>
    //           <hr />
    //           <label >
    //             <b>verificationCode</b>
    //           </label>
    //           <input
    //             type="text"
    //             placeholder="Enter verificationCode"
    //             name="verificationCode"
    //             required
    //             onChange={props.handleChange}
    //           />
    //     <br/>
    //     <label >
    //                     <b>new Password</b>
    //                   </label>
    //                   <input
    //                     type="password"
    //                     placeholder="Enter new Password"
    //                     name="password"
    //                     required
    //                     onChange={props.handleChange}
    //                   />
    //           <div className="clearfix">

    //             <button type="submit" className="signupbtn" onClick={props.handleConfirmVerification}>
    //               send verification code
    //             </button>
    //           </div>
    //         </div>
    //       </form> */}


  )
}

export default ResetPasswordForm
